import {
  GET_IMPAYES,
  GET_IMPAYES_COMPLETED,
  GET_IMPAYES_FAILED,
  GET_RECOUVREMENT_CONSTANTS_COMPLETED,
  GET_IMPAYE_DETAIL,
  GET_IMPAYE_DETAIL_COMPLETED,
  GET_IMPAYE_DETAIL_FAILED,
  GET_RECOUVREMENT_BROUILLON_COMPLETED,
} from "./actions";

const initialState = {
  impayes: [],
  count: 0,
  masqueesRelance: 0,
  isLoading: false,
  isInitialized: false,
  constants: null,
  current: {
    data: null,
    isLoading: false,
  },
  brouillon: null,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMPAYES:
      return { ...state, isLoading: true };
    case GET_IMPAYES_COMPLETED:
      return {
        ...state,
        impayes: action.payload.result.impayes || [],
        count: action.payload.result.count || 0,
        masqueesRelance: action.payload.result.masquees_relance || 0,
        isLoading: false,
        isInitialized: true,
      };
    case GET_IMPAYES_FAILED:
      return { ...state, isLoading: false, isInitialized: true };

    case GET_RECOUVREMENT_CONSTANTS_COMPLETED:
      return { ...state, constants: action.payload.result };

    case GET_IMPAYE_DETAIL:
      return { ...state, current: { ...state.current, isLoading: true } };
    case GET_IMPAYE_DETAIL_COMPLETED:
      return {
        ...state,
        current: { data: action.payload.result, isLoading: false },
      };
    case GET_IMPAYE_DETAIL_FAILED:
      return { ...state, current: { data: null, isLoading: false } };

    case GET_RECOUVREMENT_BROUILLON_COMPLETED:
      return { ...state, brouillon: action.payload.result.brouillon || null };

    default:
      return state;
  }
};

export default reducers;
